import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { sendContact } from "../api";
import { useData } from "../context/DataContext";
import { FaPhone, FaEnvelope } from "react-icons/fa";
import { AiOutlineCheckCircle } from "react-icons/ai";

function ContactForm() {
  const { t, i18n } = useTranslation();
  const { profile } = useData();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null,
  });
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success",
  });

  const showToast = (message, variant = "success") => {
    setToast({ show: true, message, variant });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });
    try {
      await sendContact({ ...formData, language: i18n.language.split("-")[0] });
      setStatus({ loading: false, success: true, error: null });
      setFormData({ name: "", email: "", message: "" });
      showToast(
        i18n.language.startsWith("uz")
          ? "✅ Xabaringiz muvaffaqiyatli yuborildi!"
          : "✅ Message sent successfully!",
        "success"
      );
    } catch (err) {
      setStatus({ loading: false, success: false, error: t("send_error") });
      showToast(
        i18n.language.startsWith("uz")
          ? "❌ Xatolik yuz berdi!"
          : "❌ Failed to send message!",
        "danger"
      );
    }
  };

  return (
    <Container className="mt-5 pb-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <h1 className="project-heading text-center">
            {t("contact_me", "Get In Touch")}{" "}
          </h1>

          {(profile?.contact?.phone || profile?.contact?.email) && (
            <div className="text-center mb-4" style={{ marginTop: "30px" }}>
              {profile?.contact?.email && (
                <div className="mb-3">
                  <FaEnvelope
                    style={{
                      color: "#c770f0",
                      marginRight: "10px",
                      fontSize: "1.2rem",
                    }}
                  />
                  <a
                    href={`mailto:${profile.contact.email}`}
                    style={{
                      color: "#fff",
                      fontSize: "1.1rem",
                      textDecoration: "none",
                    }}
                  >
                    {profile.contact.email}
                  </a>
                </div>
              )}
              {profile?.contact?.phone && (
                <div className="mb-3">
                  <FaPhone
                    style={{
                      color: "#c770f0",
                      marginRight: "10px",
                      fontSize: "1.2rem",
                    }}
                  />
                  <a
                    href={`tel:${profile.contact.phone}`}
                    style={{
                      color: "#fff",
                      fontSize: "1.1rem",
                      textDecoration: "none",
                    }}
                  >
                    {profile.contact.phone}
                  </a>
                </div>
              )}
            </div>
          )}

          <Form onSubmit={handleSubmit} className="mt-4 contact-form">
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="name"
                placeholder={t("your_name", "Your Full Name")}
                value={formData.name}
                onChange={handleChange}
                required
                className="bg-transparent text-white contact-input"
                style={{
                  border: "1px solid #c770f0",
                  padding: "12px 20px",
                  fontSize: "1rem",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                name="email"
                placeholder={t("your_email", "Your Email Address")}
                value={formData.email}
                onChange={handleChange}
                required
                className="bg-transparent text-white contact-input"
                style={{
                  border: "1px solid #c770f0",
                  padding: "12px 20px",
                  fontSize: "1rem",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                rows={5}
                name="message"
                placeholder={t("your_message", "Your Message")}
                value={formData.message}
                onChange={handleChange}
                required
                className="bg-transparent text-white contact-input"
                style={{
                  border: "1px solid #c770f0",
                  padding: "12px 20px",
                  fontSize: "1rem",
                }}
              />
            </Form.Group>
            <div className="text-center">
              <Button variant="primary" type="submit" disabled={status.loading}>
                {status.loading
                  ? t("sending", "Sending...")
                  : t("send_message", "Send Message")}
              </Button>
            </div>
            {status.success && (
              <p className="text-success text-center mt-3">
                {t("send_success", "Message sent successfully!")}
              </p>
            )}
            {status.error && (
              <p className="text-danger text-center mt-3">{status.error}</p>
            )}
          </Form>
        </Col>
      </Row>

      {/* Toast Notifications */}
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ position: "fixed", top: 20, right: 20, zIndex: 9999 }}
      >
        <Toast
          show={toast.show}
          onClose={() => setToast({ ...toast, show: false })}
          bg={toast.variant === "success" ? "dark" : "danger"}
          delay={4000}
          autohide
        >
          <Toast.Body
            className="d-flex align-items-center gap-2 text-white"
            style={{ fontSize: "1rem" }}
          >
            {toast.variant === "success" ? (
              <AiOutlineCheckCircle size={20} color="#4ade80" />
            ) : (
              <span>⚠️</span>
            )}
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
}

export default ContactForm;
